export default function iframeOnload() {
    return {
        scope: {
            callBack: '&iframeOnload',
        },
        link(scope, element) {
            element.on('load', () => scope.callBack());
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/iframeOnload.directive.js